import { Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import last from "../../../assets/images/last.png";
import line from "../../../assets/images/line.png";
import styles from "../eight/eight.module.scss";

const Eight = () => {
  const navigate = useNavigate();
  return (
    <div className={styles.main_wrapper}>
      <Container>
        <div className={styles.main}>
          <Row>
            <Col lg={6} className="p-0 text-end">
              <img className={styles.img_new} src={last} />
            </Col>
            <Col lg={6} className={styles.col_}>
              <div className={styles.blue}>
                <p className={styles.ins}>
                  {" "}
                  Join us <img src={line} />
                </p>
                <p className={styles.work}>
                  If you're a licensed inspector join our dynamic team!
                </p>
                <p className={styles.licensed}>
                  Learn how you can become an integral part of our mission and
                  contribute your expertise to our growing team.
                </p>
                <p className={styles.button_}>
                  <button
                    onClick={() => {
                      navigate("/inspector-contact");
                    }}
                  >
                    JOIN US
                  </button>
                </p>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </div>
  );
};
export default Eight;
